import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/react-hooks";

import LoadingSpinner from "core/LoadingSpinner";
import BodyText from "core/BodyText";
import ProfileHeaderLocation from "./ProfileHeaderLocation";
import ProfileHeaderSocials from "./ProfileHeaderSocials";

import {
    Container,
    Avatar,
    Name,
    Description,
    SocialsContainer,
    Website,
    NameAndLocationContainer
} from "./styles";

import { GET_CREATOR_PROFILE_INFO } from "./queries";

const ProfileHeader = ({ username }) => {
    const { data, loading } = useQuery(GET_CREATOR_PROFILE_INFO, {
        variables: {
            username
        }
    });

    if (loading) return <LoadingSpinner />;

    const { info } = data;

    return (
        <Container>
            <Avatar src={info.avatarUrl} alt={`${username} avatar`} />
            <NameAndLocationContainer>
                <Name>{info.name || info.username}</Name>
                {(info.city || info.country) && (
                    <ProfileHeaderLocation
                        city={info.city}
                        country={info.country}
                    />
                )}
            </NameAndLocationContainer>
            {info.description && <Description>{info.description}</Description>}
            <SocialsContainer>
                {<ProfileHeaderSocials creatorProfile={info} />}
                {info.website && (
                    <div>
                        <Website
                            data-testid="website-link"
                            href={`${info.website}`}
                            target="_blank"
                            title={`Creator Website`}
                            mode="dark"
                            linkType="primary"
                        >
                            <BodyText size="lg">{info.website}</BodyText>
                        </Website>
                    </div>
                )}
            </SocialsContainer>
        </Container>
    );
};

ProfileHeader.propTypes = {
    username: PropTypes.string.isRequired
};

export default ProfileHeader;
